var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('QrcodeStream',{on:{"decode":_vm.onDecode}}),_c('Button',{attrs:{"secondary":"","text":"Назад"},on:{"click":function($event){return _vm.$emit('openMainSlide')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }